import { render } from "./penyediaanNew.vue?vue&type=template&id=458daafe&ts=true"
import script from "./penyediaanNew.vue?vue&type=script&lang=ts"
export * from "./penyediaanNew.vue?vue&type=script&lang=ts"

import "./penyediaanNew.vue?vue&type=style&index=0&id=458daafe&lang=scss"

import exportComponent from "/home/vendor/oesb/ispk-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__